export default {
    "settings.title": "Settings",
    "settings.description": "Manage your account, preferences, and subscription.",
    "settings.nav.profile": "Profile",
    "settings.nav.appearance": "Appearance",
    "settings.nav.notifications": "Notifications",
    "settings.nav.security": "Security",
    "settings.nav.billing": "Billing",
    "settings.nav.logout": "Logout",

    "settings.profile.title": "Personal Information",
    "settings.profile.subtitle": "Update your basic information.",
    "settings.profile.name": "Full Name",
    "settings.profile.name_placeholder": "Your name",
    "settings.profile.email": "Email address",
    "settings.profile.email_help": "Email cannot be changed for security reasons.",
    "settings.profile.save": "Save Changes",
    "settings.profile.success": "Profile updated successfully!",

    "settings.appearance.title": "Personalization",
    "settings.appearance.subtitle": "Tailor the interface to your preferences.",
    "settings.appearance.mode": "Current mode:",
    "settings.appearance.light": "Light",
    "settings.appearance.dark": "Dark",

    "settings.security.title": "Password",
    "settings.security.subtitle": "Change your password for better security.",
    "settings.security.current_password": "Current Password",
    "settings.security.new_password": "New Password",
    "settings.security.confirm_password": "Confirm New Password",
    "settings.security.update": "Update Password",
    "settings.security.success": "Password updated successfully!",
    "settings.security.error_match": "Passwords do not match.",
    "settings.security.error_length": "Password must be at least 6 characters.",
    "settings.security.error_current": "Current password is incorrect.",

    "settings.billing.title": "Subscription & Billing",
    "settings.billing.subtitle": "Manage your payments and current plan.",
    "settings.billing.current_plan": "Current Plan",
    "settings.billing.free_plan": "Free Version",
    "settings.billing.status_active": "Active",
    "settings.billing.status_canceled": "Canceled",
    "settings.billing.view_offers": "View Offers",
    "settings.billing.renewal": "Renewal on",
    "settings.billing.ends": "Ends on",
    "settings.billing.price_yearly": "{{price}}$ / year",
    "settings.billing.price_monthly": "{{price}}$ / month",
    "settings.billing.change_plan": "Change Plan",
    "settings.billing.portal_title": "Stripe Management",
    "settings.billing.portal_description": "Manage your invoices, payment method, and cancellation via our secure portal.",
    "settings.billing.portal_cta": "Access Customer Portal",
    "settings.billing.portal_error": "Error accessing portal",
    "settings.billing.portal_error_help": "Please contact support if the problem persists.",

    "settings.danger.title": "Danger Zone",
    "settings.danger.description": "Deleting your account is irreversible. All your data, progress, and badges will be permanently erased.",
    "settings.danger.cta": "Delete My Account",

    "settings.delete.title": "Delete Account",
    "settings.delete.warning": "Are you absolutely sure? This action cannot be undone.",
    "settings.delete.confirm_help": "Please enter your email ({{email}}) to confirm deletion.",
    "settings.delete.placeholder": "Confirm your email",
    "settings.delete.cancel": "Cancel",
    "settings.delete.confirm": "Delete Permanently",
    "settings.delete.deleting": "Deleting...",
    "settings.delete.error_email": "Entered email does not match.",
    "settings.delete.error_generic": "An error occurred during deletion."
};
